import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Avatar, Chip, IconButton, InputAdornment } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useLanguage } from 'Context/LanguageContext';
import Grid from '@mui/material/Grid2';
import TextField from '~/TextField/TextField.component';

const TaskTags = ({tagsDataAux}, ref) => {

	const lan = useLanguage();	
	const getTagsData = (tags) => {
		let tagsData = [];
		tags.forEach((tag) => {
			tagsData.push({
				key: tag,
				label: tag,
			});
		});
		return tagsData;
	};

	const [tagsData, setTagsData] = useState(tagsDataAux ? getTagsData(tagsDataAux) : []);
	const [tagToAdd, setTagToAdd] = useState('');
	useImperativeHandle(ref, () => tagsData, [tagsData]);
	const handleDelete = (chipToDelete) => () => {
		setTagsData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
	};


	const addTag = () => {
		let tags = tagsData;
		let foundTag = tags.find((tag) => tagToAdd === tag.label);
		if (!foundTag) {
			tags.push({
				key: tagToAdd,
				label: tagToAdd,
			});
			setTagsData(tags);
		}
		updateTagToAdd('');
	};
	const onKeyAddTag = (e) => {
		if (e.keyCode === 13) addTag();
	};
	const updateTagToAdd = (name) => setTagToAdd(name);
	return (
		<Grid size={12} container spacing={2} sx={{ mt: 3 }}>
			<Grid size={12} container>
				<Grid size={10}>
					<TextField
						id='txt-tags'
						label={`${lan.tags} (${lan.optional})`}
						variant='outlined'
						value={tagToAdd}
						onKeyDown={onKeyAddTag}
						onChange={(e) => updateTagToAdd(e.target.value)}
						fullWidth
						startAdornment={(
							<InputAdornment position='start'>
								<LocalOfferIcon style={{ color: '#EDABC1' }} />
							</InputAdornment>
						)}
					/>
				</Grid>
				<Grid size={1}>
					<IconButton onClick={addTag} size={'large'}>
						<AddCircleIcon style={{ color: '#DC5C87' }} />
					</IconButton>
				</Grid>
			</Grid>
			<Grid size={12}>
        {tagsData.map((data) => (
          <Chip
            className='mx-2 my-1'
            avatar={<Avatar>#</Avatar>}
            key={data.key}
            label={data.label}
            onDelete={handleDelete(data)}
          />
        ))}
			</Grid>
		</Grid>
	);
};

export default forwardRef(TaskTags);
